module.exports = __webpack_public_path__ + "media/music/bells_6-63b814e1.mp3";